import { render } from "./AccountBalancesWidget.vue?vue&type=template&id=69ac963a"
import script from "./AccountBalancesWidget.vue?vue&type=script&lang=js"
export * from "./AccountBalancesWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__